import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PriorityProspectAnalytics = () => {
    const location = useLocation();

    function getPageId(pathname) {
        // Domains
        if (pathname === "/domains") {
            return "domains";
        }

        if (/^\/domains\/[^/]+\/?$/.test(pathname)) {
            return "domain-group";
        }

        // IP addresses
        if (pathname === "/ip-addresses") {
            return "ip-addresses";
        }

        if (/^\/ip-addresses\/[^/]+\/?$/.test(pathname)) {
            return "ip-address-group";
        }

        // Hosting
        if (pathname === "/hosting") {
            return "hosting";
        }

        if (/^\/hosting\/[^/]+\/?$/.test(pathname)) {
            return "hosting-account";
        }

        // Firewall
        if (pathname === "/firewall") {
            return "firewall";
        }

        if (/^\/firewall\/edit\/[^/]+\/?$/.test(pathname)) {
            return "firewall-rule-edit";
        }

        if (pathname === "/firewall/policies") {
            return "firewall-policies";
        }

        if (pathname === "/firewall/rulesets") {
            return "firewall-rulesets";
        }

        // Website restoration
        if (pathname === "/website-restoration") {
            return "website-restoration";
        }

        if (/^\/website-restoration\/[^/]+\/?$/.test(pathname)) {
            return "website-restoration-project";
        }

        // Content
        if (pathname === "/content") {
            return "content-writer";
        }

        if (
            /^\/content\/[^/]+\/articles\/[^/]+\/?$/.test(pathname)
        ) {
            return "content-writer-article";
        }

        if (/^\/content\/[^/]+\/?$/.test(pathname)) {
            return "content-writer";
        }

        // Billing
        if (pathname === "/billing") {
            return "billing-orders";
        }

        if (/^\/billing\/orders\/[^/]+\/?$/.test(pathname)) {
            return "billing-order";
        }

        if (pathname === "/billing/invoices") {
            return "billing-invoices";
        }

        if (/^\/billing\/invoices\/[^/]+\/?$/.test(pathname)) {
            return "billing-invoice";
        }

        if (pathname === "/billing/payment-methods") {
            return "billing-payment-methods";
        }

        if (pathname === "/billing/transactions") {
            return "billing-transactions";
        }

        if (pathname === "/billing/cancellation-requests") {
            return "billing-cancellation-requests";
        }

        if (pathname === "/billing/credit-notes") {
            return "billing-credit-notes";
        }

        // Services
        if (pathname === "/services") {
            return "services";
        }

        // Affiliate
        if (pathname === "/affiliate") {
            return "affiliate";
        }

        if (pathname === "/affiliate/links") {
            return "affiliate-links";
        }

        if (pathname === "/affiliate/reports") {
            return "affiliate-reports";
        }

        if (pathname === "/affiliate/billing") {
            return "affiliate-billing";
        }

        if (pathname === "/support") {
            return "support";
        }

        if (pathname === "/account/profile") {
            return "account-profile";
        }

        if (pathname === "/account/companies") {
            return "account-companies";
        }

        if (pathname === "/account/invitations") {
            return "account-invitations";
        }

        if (pathname === "/account/emails") {
            return "account-emails";
        }

        if (pathname === "/account/logins") {
            return "account-logins";
        }

        if (pathname === "/account/logs") {
            return "account-logs";
        }

        // Company
        if (pathname === "/company") {
            return "company-profile";
        }

        if (pathname === "/company/vat") {
            return "company-vat";
        }

        if (pathname === "/company/users") {
            return "company-users";
        }

        if (pathname === "/company/contacts") {
            return "company-contacts";
        }

        if (pathname === "/company/emails") {
            return "company-emails";
        }

        if (pathname === "/company/logs") {
            return "company-logs";
        }

        if (pathname === "/company/api") {
            return "company-api";
        }

        if (pathname === "/company/webhooks") {
            return "company-webhooks";
        }

        // Fallback
        const normalized = pathname
            .replace(/^\/+|\/+$/g, "")
            .replace(/\//g, "_");

        return normalized || "dashboard";
    }

    useEffect(() => {
        const trackPage = () => {
            if (!window.PPA) {
                return false;
            }

            window.PPA.page({
                id: getPageId(location.pathname),
                type: "panel",
                host: window.location.hostname,
                path: location.pathname,
                content_id: ""
            });

            return true;
        };

        if (trackPage()) {
            return;
        }

        const timeout = window.setTimeout(
            trackPage,
            100
        );

        return () => {
            window.clearTimeout(timeout);
        };
    }, [location.pathname]);

    return null;
};

export default PriorityProspectAnalytics;